import { render, staticRenderFns } from "./ForestStand.vue?vue&type=template&id=bc71ee4e&scoped=true&"
import script from "./ForestStand.vue?vue&type=script&lang=js&"
export * from "./ForestStand.vue?vue&type=script&lang=js&"
import style0 from "./ForestStand.vue?vue&type=style&index=0&id=bc71ee4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc71ee4e",
  null
  
)

export default component.exports